var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconArrowRound(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.242,
    height: 16.242,
    viewBox: "0 0 16.242 16.242",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_47",
    "data-name": "Tracciato 47",
    d: "M10.2,14.637a.757.757,0,0,0,0,1.066l3.737,3.725a.753.753,0,0,0,1.038.023l3.682-3.67A.752.752,0,1,0,17.6,14.716l-3.162,3.116-3.166-3.2a.754.754,0,0,0-1.066,0Z",
    transform: "translate(-6.314 -8.284)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_48",
    "data-name": "Tracciato 48",
    d: "M3.375,11.5A8.121,8.121,0,1,0,11.5,3.375,8.12,8.12,0,0,0,3.375,11.5ZM16.353,6.639a6.869,6.869,0,1,1-9.714,9.714,6.869,6.869,0,1,1,9.714-9.714Z",
    transform: "translate(-3.375 -3.375)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowRound);
export default __webpack_public_path__ + "static/media/icon_arrow_round.8b34d0f249132a760b878a704d593208.svg";
export { ForwardRef as ReactComponent };